import { useEffect, useState } from "react";
import { playRing } from "@/lib/audio";

// While a reminder popup sits untouched, Mochi visibly worries → frustrates.
// Returns the current nervousness level (0=calm, 1=worried, 2=frustrated)
// and pipes nervous speech-bubble lines to the host via `onBubble`.
//
//   const nervousness = useReminderNervousness({ active, onBubble });
//
// `active` should be true only when a REMINDER popup is open. Re-bell rings
// trigger every 30s once we hit worried.
export function useReminderNervousness({ active, onBubble }) {
    const [nervousness, setNervousness] = useState(0);

    useEffect(() => {
        if (!active) {
            setNervousness(0);
            return;
        }
        setNervousness(0);

        const t1 = setTimeout(() => setNervousness(1), 25_000);
        const t2 = setTimeout(() => setNervousness(2), 60_000);
        let pingId = null;
        const t3 = setTimeout(() => {
            pingId = setInterval(() => {
                try { playRing(2); } catch { /* ignore */ }
            }, 30_000);
        }, 30_000);
        const t4 = setTimeout(() => onBubble?.("Um… did you catch that reminder? 👉👈"), 25_000);
        const t5 = setTimeout(() => onBubble?.("H-hey! That reminder is still waiting! 😟"), 60_000);

        return () => {
            clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
            clearTimeout(t4); clearTimeout(t5);
            if (pingId) clearInterval(pingId);
        };
    }, [active, onBubble]);

    return nervousness;
}
